
export class EnvironmentNames{
    public static  BhpGeomeasurementDeveloping = "bhp_development_geomeasurement"
    public static  BhpGeomeasurementStaging = "bhp_staging_geomeasurement"
    public static  BhpGeomeasurementProduction = "bhp_production_geomeasurement"
    public static  Geomeasurement = "Geomeasurement"
}